export enum Sounds {
    NEW_MESSAGE = 'https://d2eli1wrotxo1h.cloudfront.net/assets/sounds/new_message/audio.mp3',
}
